<template>
  <CSelect
    class="w-auto"
    :consistent-menu-width="false"
    :options="alignmentOptions"
    :renderLabel="renderLabel"
    :showCheckmark="false"
    :value="alignment"
    @update:value="editor.chain().focus().setTextAlign($event).run()"
  />
</template>

<script lang="ts" setup>
import type { Editor } from '@tiptap/vue-3'
import type { Option } from '@lib/components/CRichTextEditor/components/CEditorMenu.vue'
import type { VNode } from 'vue'
import { computed } from 'vue'
import CSelect from '@lib/components/CSelect/CSelect.vue'
import { useI18n } from 'vue-i18n'

enum Alignment {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}

interface Props {
  editor: Editor
  renderLabel: (option: Option) => VNode
}

const props = defineProps<Props>()
const { t } = useI18n()

const alignment = computed(
  () =>
    props.editor.getAttributes('heading').textAlign ??
    props.editor.getAttributes('paragraph').textAlign ??
    Alignment.LEFT,
)

const alignmentOptions: Option[] = [
  {
    value: Alignment.LEFT,
    icon: 'align-left',
    label: t('canvasUI.CRichTextEditor.left'),
  },
  {
    value: Alignment.CENTER,
    icon: 'align-center',
    label: t('canvasUI.CRichTextEditor.center'),
  },
  {
    value: Alignment.RIGHT,
    icon: 'align-right',
    label: t('canvasUI.CRichTextEditor.right'),
  },
]
</script>
